import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isNull } from 'lodash';
import { HashRouter } from 'react-router-dom';
import { Client } from '../lib/graphql';
import useToken from '../hooks/useToken';
import useLocalStorage from '../hooks/useLocalStorage';
import { preferredContactMethods, defaultCanadaProvince } from '../lib/consts';

const initState = {
  client: new Client(),
};

const defaultRegisterFormData = {
  // firstName: 'John',
  // lastName: 'Doe',
  // postalCode: 'B3S 1E6',
  // address: '31 Wembley Pl',
  // email: 'john@doe.com',
  // emailConfirmation: 'john@doe.com',
  // phone: '9029151208',
  state: defaultCanadaProvince,
  preferredContactMethod: preferredContactMethods.email.value,
};

export const Context = createContext(initState);

export function Provider({ children }) {
  const [client, setClient] = useState(initState.client);
  const { token, tokenData, setToken } = useToken();
  const [memberships, setMemberships] = useLocalStorage('portal:memberships', {});
  const [toasts, setToasts] = useState([]);
  const [registerFormData, setRegisterFormData] = useLocalStorage('portal:register-form-data', defaultRegisterFormData);
  useEffect(() => {
    if (!isNull(token)) {
      setClient(new Client({ token }));
    }
  }, [token]);
  return (
    <HashRouter>
      <Context.Provider
        value={{
          ...initState,
          token,
          client,
          tokenData,
          setToken,
          memberships,
          registerFormData,
          setRegisterFormData,
          resetRegisterFormData() {
            setRegisterFormData(defaultRegisterFormData);
          },
          setMemberships(membership) {
            setMemberships({
              ...memberships,
              [membership.id]: membership,
            });
          },
          toasts,
          setToasts,
          insertToast(toast) {
            setToasts([toast, ...toasts]);
          },
        }}
      >
        {children}
      </Context.Provider>
    </HashRouter>
  );
}

Provider.propTypes = {
  children: PropTypes.node,
};

Provider.defaultProps = {
  children: undefined,
};
